import React, {useEffect, useRef, useState} from 'react';
import styles from './Video.module.scss'
import macroStyles from "components/homePanels/f-i_macroPage/MacroPage.module.scss";
import ScrollEvent from "utils/ScrollEvent";
import ImageWrapper from "components/imageWrapper/ImageWrapper";
import layerStyles from "components/homePanels/f-i_macroPage/heroLayers/Layers.module.scss";
import CacheSquare from "components/homePanels/f-i_macroPage/heroLayers/CacheSquare";
import {useDispatch, useSelector} from "react-redux";
import {buttonClick} from "utils/Helpers";
import {iOS} from "utils/Device";

const Video = (props) => {

    const accessible = useSelector(state => state.accessible);
    const windowData = useSelector(state => state.window);
    const dispatch = useDispatch();
    const macro = props.macro.toLowerCase();
    const videoTag = useRef();
    const poster = useRef();
    const wrapper = useRef();
    const [isPlaying, setIsPlaying] = useState(false);
    const [hidePoster, setHidePoster] = useState(false);
    const [frameSrc, setFrameSrc] = useState();
    const [videoSrc, setVideoSrc] = useState();
    const currentVideo = useRef();

    const posterSet = {
        767: `https://msobd-storage.azureedge.net/images/profile_${macro}/poster_800_p.jpg`,
        default:`https://msobd-storage.azureedge.net/images/profile_${macro}/poster.jpg`
    }

    useEffect(()=>{
        let set = {
            // 544: `url(https://msobd-storage.azureedge.net/images/profile_${macro}/videoBgx400_p.png)`,
            767: `url(https://msobd-storage.azureedge.net/images/profile_${macro}/videoBgx800_p.png)`,
            1350: `url(https://msobd-storage.azureedge.net/images/profile_${macro}/videoBgx1350.png)`,
            default: `url(https://msobd-storage.azureedge.net/images/profile_${macro}/videoBg.png)`
        }

        let sizeFound = false;
        let sourceFound = set['default'];
        delete set['default'];

        for (let [key, value] of Object.entries(set)) {
            if(key !== 'default' && !sizeFound && windowData.width < parseInt(key)) {
                sizeFound = true;
                sourceFound = value;
            }
        }

        if(sourceFound !== frameSrc) setFrameSrc(sourceFound);

    },[windowData,macro,frameSrc,setFrameSrc])


    function playVideo(){
        setIsPlaying(true);

        setTimeout(()=>{
            videoTag.current.textTracks[0].mode = 'hidden';
            videoTag.current.play();
        }, 100)

    }

    function isVideoPlaying(play){
        dispatch({ type: "SET_ACCESSIBLE",
            payload: {
                ...accessible,
                videoActive: play
            }
        });
    }

    function inViewCheck(e){
        /** no actual view check required, this triggers when you scroll in this div,
         * which causes you to leave the view anyway **/

        if(videoTag.current){

            let rect = videoTag.current.getBoundingClientRect();

            let pause = false;
            if(Math.abs(rect.top) > rect.height/2) pause = true;

            if(isPlaying && pause){
                videoTag.current.pause();
                setIsPlaying(false);
                setHidePoster(false);
            }

        }

    }

    function showVideo(){
        // videoTag.current.style.opacity = 1;
        setHidePoster(true)
    }

    function buildBgLayers(){
        if(props.macro === 'cache'){
            return (
                <>
                    <div aria-hidden={true} className={layerStyles.cacheSquare3}>
                        <CacheSquare/>
                    </div>
                    <div aria-hidden={true} className={layerStyles.cacheSquare4}>
                        <CacheSquare/>
                    </div>
                </>
            )
        }
    }

    useEffect(()=>{
        if(windowData.width <= 767){
            if(currentVideo.current !== props.video.portraitUrl) setVideoSrc(props.video.portraitUrl)
        } else {
            if(videoSrc !== props.video.url) setVideoSrc(props.video.url)
        }
    }, [windowData, videoSrc,  setVideoSrc, props.video])

    function addVideoClasses(){
        let classes = `${styles.videoWrapper} ${styles[macro]}`
        if(iOS()) classes = classes + ' ' + styles.ios;
        return classes
    }

    return (
        <div className={`${macroStyles.macroPanel} ${styles.contentWrapper}`}>

            {buildBgLayers()}

            <div ref={wrapper} className={addVideoClasses()} style={{backgroundImage: frameSrc}}>
                {isPlaying && (
                    <video key={videoSrc} aria-label={`${props.title} video`}
                           onCanPlay={showVideo} onPause={()=>isVideoPlaying(false)} onPlay={()=>isVideoPlaying(true)}
                           ref={videoTag} playsInline controls preload="metadata">
                        <source src={videoSrc} type="video/mp4"/>
                        <track label="English" kind="subtitles" srcLang="en" src={props.video.cc} default/>
                    </video>
                    )
                }
                <div aria-hidden={true} className={isPlaying ? styles.hideMe : styles.showMe}>
                    <ImageWrapper ref={poster} className={styles.poster}
                                  set={posterSet}
                                  alt={'Video Poster'} scaleDown={true}/>
                </div>
                {!hidePoster && <ImageWrapper tabIndex={0} role={'button'} aria-label={'Play video'} onKeyDown={buttonClick} className={styles.play} onClick={playVideo} set={{default:'https://msobd-storage.azureedge.net/images/play.png'}} alt={'Play Video Icon'}/>}

                {/*{isPlaying && <span tabIndex={0} role={'button'} aria-label={'Closed Caption Toggle'} onKeyDown={buttonClick} className={styles.cc}  onClick={toggleCC}>*/}
                {/*                <ClosedCaption/>*/}
                {/*            </span>}*/}
                {/*{isPlaying && <span tabIndex={0} role={'button'} aria-label={'Close video'} onKeyDown={buttonClick} className={styles.close}  onClick={stopVideo}>*/}
                {/*                <NavToggle menuOpen={true} closeOnly={true} dark={true}/>*/}
                {/*            </span>}*/}

            </div>

            <ScrollEvent target={wrapper.current} scroll={inViewCheck} debounce={500} />


        </div>
    )
};

export default Video
